import SuportIndex from '../views/Suport/Index'

let routes = {
    path: '/help_desk',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/help_desk',
            name: 'list-help-desk',
            component: SuportIndex,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Suporte Técnico 24 horas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
